import { useState } from "react";
import { getCardImage } from "../../resultVisuals/cardAssets";
import CardImg from "../../../../components/CardImg";

/**
 * Casino War video card overlay in the reference markup:
 *   .casino-video-cards[.hide-cards] > .casino-cards-shuffle + .casino-video-cards-container > <span><img dealer card></span>
 * The dealer card is the 7th card of the feed (cards[6]). Hidden while cards[0] is a back ("1");
 * the shuffle handle toggles it (reference toggleCards).
 */
export default function WarCardsOverlay({ card }) {
  const [showCards, setShowCards] = useState(true);
  if (card == null || !String(card).length) return null;
  const cards = String(card).split(",").map((c) => c.trim());
  const hidden = !showCards || cards[0] === "1";

  if (cards[0] === "1" && !showCards) setShowCards(true); // new round re-opens a hand-closed strip
  return (
    <div className={`casino-video-cards${hidden ? " hide-cards" : ""}`}>
      <div className="casino-cards-shuffle" onClick={() => cards[0] !== "1" && setShowCards((v) => !v)}>
        <i className="fas fa-grip-lines-vertical" />
      </div>{" "}
      <div className="casino-video-cards-container">
        <span>
          <CardImg src={getCardImage(cards[6])} alt="" />
        </span>
      </div>
    </div>
  );
}
